module.exports = __webpack_public_path__ + "static/media/arrowRight.5f482d99.svg";